import authLocalFe from '@blaze-cms/plugin-auth-local-fe';

export default function buildBaseConfig(config) {
  // Plugins common to ALL projects. Project-specific plugins live in
  // projects/[project key]/packages/frontend/project/blaze.config.js.
  config.plugins.set(authLocalFe, {});

  // project plugins

  // eslint-disable-next-line no-param-reassign
  config.apollo = {
    ...config.apollo,
    disableUpload: true
  };
  return config;
}
